import { create } from "zustand"

export const aptGroupStore = create((set) => ({
  groups: [],
  setGroups: (groups) =>
    set((state) => ({
      groups: typeof groups === "function" ? groups(state.groups) : groups
    })),

  tempGroups: [],
  setTempGroups: (tempGroups) => set({ tempGroups }),

  initTempGroups: () =>
    set((state) => ({
      tempGroups: state.groups.map((group) => ({
        ...group,
        codes: [...(group.codes ?? [])]
      }))
    })),

  updateTempGroupCodes: (groupId, codes) =>
    set((state) => ({
      tempGroups: state.tempGroups.map((group) =>
        group.id === groupId ? { ...group, codes } : group
      )
    })),

  clearTempGroups: () => set({ tempGroups: [] }),

  activeGroupName: "",
  setActiveGroupName: (activeGroupName) => set({ activeGroupName }),

  groupAptList: [],
  setGroupAptList: (groupAptList) => set({ groupAptList })
}))
